import React, { Component } from 'react';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { Analytics } from '@trello/atlassian-analytics';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import styles from './LinkCopy.less';
import { forNamespace } from 'app/common/lib/util/i18n';
import { featureFlagClient } from '@trello/feature-flag-client';

const format = forNamespace('link copy');

interface LinkCopyProps {
  url: string;
  eventCategory: Noun;
  boardId?: string;
  teamId?: string;
  isTemplate?: boolean;
}

export class LinkCopy extends Component<LinkCopyProps, { buttonText: string }> {
  linkInput = React.createRef<HTMLInputElement>();
  timer: number;
  isTemplate: boolean;

  state = {
    buttonText: format('copy'),
  };

  componentDidMount() {
    const linkInput = this.linkInput.current;
    if (linkInput) {
      setTimeout(() => {
        linkInput.select();
      }, 10);
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  getEventContext = () => {
    return {
      boardId: this.props.boardId || '',
      teamId: this.props.teamId || '',
    };
  };

  handleButtonClick = () => {
    if (this.linkInput.current) {
      this.linkInput.current.select();
      document.execCommand('copy');
      this.setState({ buttonText: format('copied') });
    }

    // Create a timeout to change "Copied!" back to "Copy" as a visual indicator
    // that the link has successfully completed being copied to the clipboard
    this.timer = window.setTimeout(() => {
      this.setState({ buttonText: format('copy') });
    }, 2000);

    trackUe({
      category: this.props.eventCategory,
      verb: Verb.COPIES,
      directObj: Noun.BOARD_SHORT_URL,
      method: 'by clicking on the copy button',
      context: this.getEventContext(),
    });

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'linkCopyButton',
      source: 'linkCopyInlineDialog',
      containers: {
        board: { id: this.props.boardId || '' },
        organization: { id: this.props.teamId || '' },
      },
      attributes: { isTemplate: this.props.isTemplate },
    });
  };

  handleInputClick = () => {
    if (this.linkInput.current) {
      this.linkInput.current.select();
    }

    trackUe({
      category: this.props.eventCategory,
      verb: Verb.HIGHLIGHTS,
      directObj: Noun.BOARD_SHORT_URL,
      prepositionalObj: 'in input box',
      method: 'by clicking on it',
      context: this.getEventContext(),
    });
    if (featureFlagClient.get('dataeng.gasv3-event-tracking', false)) {
      Analytics.sendUIEvent({
        action: 'clicked',
        actionSubject: 'input',
        actionSubjectId: 'linkCopyInput',
        source: 'linkCopyInlineDialog',
        containers: {
          board: { id: this.props.boardId || '' },
          organization: { id: this.props.teamId || '' },
        },
        attributes: { isTemplate: this.props.isTemplate },
      });
    }
  };

  render() {
    return (
      <div className={styles.shareLinkContainer}>
        <input
          readOnly
          value={this.props.url}
          onClick={this.handleInputClick}
          ref={this.linkInput}
        />
        <PrimaryButton
          title={this.state.buttonText}
          onClick={this.handleButtonClick}
        >
          {this.state.buttonText}
        </PrimaryButton>
      </div>
    );
  }
}
